import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";

export default function LevelingSection({
  channels = [],
  levelingEnabled,
  setLevelingEnabled,
  levelUpChannel,
  setLevelUpChannel,
  globalMultiplier,
  setGlobalMultiplier,
  boosterHours,
  setBoosterHours,
  multiplierExpires,
  /** Home guilds can edit XP multipliers / boosters; others only toggle + channel. */
  progressionAdmin = false,
}) {
  const boosterActive =
    multiplierExpires && new Date(multiplierExpires) > new Date();

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Global Kami XP (shared across servers) for Crystal Growth, essence, and
        quests. Turn it off here to stop global XP and essence from chat/voice{" "}
        <em>in this server</em>. For Discord roles tied to ranks in this server,
        use <strong>Server Ranks &amp; Roles</strong>. You can also use{" "}
        <code>/admin set-levelup</code> in Discord.
      </p>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        <input
          type="checkbox"
          checked={levelingEnabled}
          onChange={(e) => setLevelingEnabled(e.target.checked)}
          style={{ accentColor: "#b85c6e" }}
        />
        <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
          GLOBAL LEVELING ENABLED
        </span>
      </label>

      <label className="input-label">LEVEL-UP ANNOUNCEMENTS CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={levelUpChannel || ""}
        onChange={setLevelUpChannel}
        types={[0]}
        emptyLabel="Same channel as the message (default)"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
      >
        When someone levels up from chatting, Crystal Growth posts here instead
        of the chat they were in. Leave default to keep the old behavior.
      </p>

      {progressionAdmin ? (
        <>
          <label className="input-label" style={{ marginTop: "15px" }}>
            XP MULTIPLIER
          </label>
          <input
            type="number"
            step="0.1"
            min="1"
            className="settings-input"
            value={globalMultiplier}
            onChange={(e) =>
              setGlobalMultiplier(parseFloat(e.target.value) || 1)
            }
            placeholder="1.0"
          />

          <label className="input-label">BOOSTER DURATION (HOURS)</label>
          <input
            type="number"
            min="0"
            className="settings-input"
            value={boosterHours}
            onChange={(e) => setBoosterHours(parseInt(e.target.value) || 0)}
            placeholder="0 = keep current expiry only"
          />
          <p
            className="help-text"
            style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
          >
            Set hours &gt; 0 with a multiplier above 1 to activate a new booster
            on save. Home-server only.
          </p>

          {boosterActive && (
            <div
              style={{
                marginTop: "12px",
                padding: "10px",
                background: "rgba(184, 92, 110, 0.08)",
                borderRadius: "6px",
                fontSize: "0.85rem",
              }}
            >
              Active booster: <strong>{globalMultiplier}x</strong> until{" "}
              {new Date(multiplierExpires).toLocaleString()}
            </div>
          )}
        </>
      ) : null}
    </SettingsSection>
  );
}
